import ApiKeys from "./ApiKeys";
import Collapsible from "../collapsible/Collapsible";
import GoogleSettings from './GoogleSettings';

const Settings = () => {
    return (
        <>
            <Collapsible title="Google instellingen" defaultOpen={true}>
                <GoogleSettings />
            </Collapsible>

            <Collapsible title="API Keys">
                <ApiKeys />
            </Collapsible>
        </>
    )
};

export default Settings;
